<template>
  <div class="container" style="width:300px">
    <span style="color:red">手机端复制粘贴按钮可能不行!!建议不依靠按钮</span>

    <Form>
      <FormItem label="当前授权状态">
        <div v-html="authdescript" style="font-weight: bolder;"></div>

      </FormItem>

      <FormItem label="系统密匙">
        <Button style="float:right" size="small" type="info" class="mackey_copybtn">复制</Button>
        <Input v-model="srcVal" :rows="8" type="textarea" ref="src1" />
      </FormItem>

      <FormItem label="授权licenese">
        <Button style="float:right" size="small" type="info" @click="clip">粘贴</Button>
        <Input v-model="licVal" :rows="8" type="textarea" />
      </FormItem>

      <FormItem>
        <Button type="primary" style="flex: 1; margin: 10px 0" long @click="starauth">开始授权</Button>
        <Button type="primary" style="flex: 1; margin: 10px 0" long @click="backToHome">返回首页</Button>

      </FormItem>
    </Form>
  </div>
</template>
<script>
function copytext(text) {
  if (navigator.clipboard) {
    // clipboard api 复制
    navigator.clipboard.writeText(text)
  } else {
    var textarea = document.createElement("textarea")
    document.body.appendChild(textarea)
    // 隐藏此输入框
    textarea.style.position = "fixed"
    textarea.style.clip = "rect(0 0 0 0)"
    textarea.style.top = "10px"
    // 赋值
    textarea.value = text
    // 选中
    textarea.select()
    // 复制
    document.execCommand("copy", true)
    // 移除输入框
    document.body.removeChild(textarea)
  }
}

function base64(rawStr) {
  var wordArray = CryptoJS.enc.Utf8.parse(rawStr)
  var base64str = CryptoJS.enc.Base64.stringify(wordArray)
  return base64str
}

export default {
  data() {
    let authinfo = this.$store.state.core.user.authinfo

    let authdescript = ""

    if (authinfo.authleftdays == undefined) {
      authdescript = `<span style='color:red'>无授权</span>`
    } else if (authinfo.authleftdays < 0) {
      authdescript = `<span style='color:red'>[${authinfo.appname}]已过期${authinfo.authleftdays}天</span>`
    } else {
      authdescript = `<span style='color:green'>[${authinfo.appname}]剩余${authinfo.authleftdays}天过期</span>`
    }

    let str = JSON.stringify(authinfo)

    return {
      authdescript,
      srcVal: base64(str),
      licVal: "",
    }
  },
  computed: {},
  methods: {
    backToHome() {
      window.location.href = "./index.html"
    },
    clip() {
      navigator.clipboard.readText().then((c) => {
        this.licVal = c.toString()
        this.$toast.success("粘贴完成")
      })
    },
    copy(e) {
      if (e.shiftKey) {
        copytext(JSON.stringify(this.$store.state.core.user.authinfo))
        this.$toast.success("复制完成2")
        return
      }
      copytext(this.srcVal)
      this.$toast.success("复制完成")
    },
    starauth() {
      let { licVal } = this

      this.$curl.post("/api/core/system/writeLic", { licVal }).then(() => {
        this.$toast.success("授权完成")
        window.location.reload()
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.clipboard = new window.Clipboard(".mackey_copybtn", {
        target: function (trigger) {
          return trigger.nextElementSibling
        },
      })
    })
  },
  destroyed() {
    if (this.clipboard) this.clipboard.destroy()
  },
}
</script>
<style lang="scss" scoped>
.container {
  width: 400px;
  margin: 0 auto;
  .title {
    margin-top: 20px;
    display: block;
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }
}
</style>